import { render, staticRenderFns } from "./EmbedContainer.vue?vue&type=template&id=1327637e&scoped=true&"
import script from "./EmbedContainer.vue?vue&type=script&lang=ts&"
export * from "./EmbedContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1327637e",
  null
  
)

export default component.exports